export enum SyncStatus {
    SYNCED = 'SYNCED',
    PENDING = 'PENDING',
    FAILED = 'FAILED'
}

export interface AdminUserServerLinkDto {
    userId: string;
    tgUserName: string;
    serverId: string;
    status: SyncStatus;
    lastAttempt?: string;
    retries?: number;
    lastError?: string;
    requestDetails?: string;
}

export interface SyncFilter {
    inStatus?: SyncStatus[];
    actions?: string[];
    userIds?: string[];
    minAttempts?: number;
    maxAttempts?: number;
    serverIds?: string[];
}

export interface PaginatedSyncLinksResponse {
    data: AdminUserServerLinkDto[];
    total: number;
    page: number;
    pageSize: number;
    hasMore: boolean;
}

export interface SyncLinksPageParams {
    page?: number;
    pageSize?: number;
    status?: SyncStatus;
}
